// extracted by mini-css-extract-plugin
module.exports = {"date":"ImportDevice345Apartments_date_3IQSB"};